import { uploadDoc, uploadImg } from '../dataProvider/common'
import { OptionGroup } from './catalog/optionedProduct/types/internal/optionedProduct-models'
import {
  APIDocument,
  BrowserUploadFile,
  FormSingleDocument,
  FormImage,
  FormMultipleDocuments,
  APIImage,
} from './entities'

export const uploadOrKeepFile = (fileOrObj: FormSingleDocument | undefined) => {
  if (!fileOrObj) return []

  return 'rawFile' in fileOrObj
    ? uploadDoc(fileOrObj.rawFile).then((r) => [r])
    : fileOrObj.map((f) => f.id)
}

export const uploadOrKeepMultipleFiles = (
  fileOrObjArray: FormMultipleDocuments
) => {
  return Promise.all(
    // this casting is due to pre 4.2 TS which doens't work properly with union types and doesn't allow map to be called:
    // https://stackoverflow.com/questions/49510832/typescript-how-to-map-over-union-array-type
    (fileOrObjArray ?? ([] as Array<APIDocument | BrowserUploadFile>)).map(
      (file) => ('rawFile' in file ? uploadDoc(file.rawFile) : file.id)
    )
  )
}

export const uploadOrKeepMultipleImgs = (imgArray: FormImage[] = []) => {
  return Promise.all(
    (imgArray as Array<APIImage | BrowserUploadFile>).map((img) =>
      'rawFile' in img ? uploadImg(img.rawFile) : img.id
    )
  )
}

export const uploadOrKeepImg = (img?: FormImage) => {
  return !img || !('rawFile' in img)
    ? Promise.resolve(img?.id)
    : uploadImg(img.rawFile).then((id: string) => id)
}

export const uploadOptionImages = (optionGroup: OptionGroup[]) =>
  optionGroup.map((option) => uploadSingleImages(option.items)).flat()

export const uploadSingleImages = <T extends { image?: FormImage }>(
  products: T[]
) => products.map((e) => uploadOrKeepImg(e.image))
